
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import * as Models from "@gigalot/data-models";
import { listAnimal } from "@/helpers/graphql-list-items";
import { tagId } from "@/helpers/visual-tag";

@Component
export default class AnimalSearch extends Vue {
  @Prop({ default: "animal-data" }) nextRouteName!: string;

  animalListItems: {
    typename: string;
    guid: string;
    sgtin?: string;
    owner?: string;
    breed?: string;
    gender?: string;
    tagId?: string;
    allflex?: string;
    visualTag?: string;
  }[] = [];

  selected: any = "";
  searchInput = "";
  isLoadingAnimals = false;
  tagId = tagId;
  selectedTagType: "sgtin-ui" | "lf-tag" | "visual-tag" = "sgtin-ui";

  get searchLabel(): string {
    if (this.selectedTagType === "sgtin-ui") return "Giga Tag ID";
    if (this.selectedTagType === "lf-tag") return "LF Tag ID";
    return "Visual Tag ID";
  }

  get selectedTagField(): "tagId" | "allflex" | "visualTag" {
    if (this.selectedTagType === "sgtin-ui") return "tagId";
    if (this.selectedTagType === "lf-tag") return "allflex";
    return "visualTag";
  }

  get filteredAnimalListItems() {
    const animals = this.animalListItems.filter((animal) => !!animal[this.selectedTagField]);
    if (!this.searchInput) return animals;
    const searchInput = this.searchInput.toLowerCase();
    return animals.filter((animal) => animal[this.selectedTagField]?.toLowerCase().includes(searchInput));
  }

  @Watch("selectedTagType")
  onSelectedTagTypeChanged() {
    this.searchInput = "";
    this.selected = "";
  }

  tagDisplay(animal: any): string {
    const baseTag = this.tagId(animal.sgtin);
    if (this.selectedTagType === "lf-tag") return `${baseTag} (${animal.allflex || "N/A"})`;
    if (this.selectedTagType === "visual-tag") return `${baseTag} (${animal.visualTag || "N/A"})`;
    return baseTag;
  }

  async created() {
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => this.$router.go(-1),
    });

    this.isLoadingAnimals = true;
    try {
      this.animalListItems = await listAnimal();
    } finally {
      this.isLoadingAnimals = false;
    }
  }

  @Watch("selected")
  async onSelectedChanged(selected: any) {
    if (!selected) return;

    const json = await this.$store.dispatch(
      "graphQl",
      {
        gql: Models.gql.queries.getAnimal,
        variables: {
          guid: this.$store.state.user.location.guid,
          itemGuid: selected.guid,
        },
      },
      { root: true }
    );

    this.$router.push({ name: this.nextRouteName, params: { animal: json.data.getAnimal } });
  }
}
